// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file catalogos_aplicaciones.proto (package sextante.catalogos.aplicaciones.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catalogos_aplicaciones.proto.
 */
export const file_catalogos_aplicaciones: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Cultivo del catalogo. Las banderas is_monitoreo_* dicen que tipos de monitoreo de plagas aplican al
 * cultivo.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.CultivoItem
 */
export type CultivoItem = Message<"sextante.catalogos.aplicaciones.v1.CultivoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string nombre = 4;
   */
  nombre: string;

  /**
   * @generated from field: bool is_monitoreo_cafe = 7;
   */
  isMonitoreoCafe: boolean;

  /**
   * @generated from field: bool is_monitoreo_citricos = 8;
   */
  isMonitoreoCitricos: boolean;

  /**
   * @generated from field: bool is_monitoreo_aguacate_hass = 9;
   */
  isMonitoreoAguacateHass: boolean;

  /**
   * @generated from field: bool is_monitoreo_mango = 10;
   */
  isMonitoreoMango: boolean;

  /**
   * @generated from field: bool is_monitoreo_macadamia = 11;
   */
  isMonitoreoMacadamia: boolean;

  /**
   * @generated from field: bool is_monitoreo_guanabana = 12;
   */
  isMonitoreoGuanabana: boolean;

  /**
   * @generated from field: bool is_monitoreo_papa = 13;
   */
  isMonitoreoPapa: boolean;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.CultivoItem.
 * Use `create(CultivoItemSchema)` to create a new message.
 */
export const CultivoItemSchema: GenMessage<CultivoItem> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 0);

/**
 * Pedido del catalogo de cultivos.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListCultivosRequest
 */
export type ListCultivosRequest = Message<"sextante.catalogos.aplicaciones.v1.ListCultivosRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListCultivosRequest.
 * Use `create(ListCultivosRequestSchema)` to create a new message.
 */
export const ListCultivosRequestSchema: GenMessage<ListCultivosRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 1);

/**
 * Cultivos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListCultivosResponse
 */
export type ListCultivosResponse = Message<"sextante.catalogos.aplicaciones.v1.ListCultivosResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.aplicaciones.v1.CultivoItem items = 1;
   */
  items: CultivoItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListCultivosResponse.
 * Use `create(ListCultivosResponseSchema)` to create a new message.
 */
export const ListCultivosResponseSchema: GenMessage<ListCultivosResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 2);

/**
 * Tratamiento de cultivo del catalogo.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.CultivoTratamientoItem
 */
export type CultivoTratamientoItem = Message<"sextante.catalogos.aplicaciones.v1.CultivoTratamientoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string tratamiento = 4;
   */
  tratamiento: string;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.CultivoTratamientoItem.
 * Use `create(CultivoTratamientoItemSchema)` to create a new message.
 */
export const CultivoTratamientoItemSchema: GenMessage<CultivoTratamientoItem> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 3);

/**
 * Pedido del catalogo de tratamientos.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListCultivoTratamientosRequest
 */
export type ListCultivoTratamientosRequest = Message<"sextante.catalogos.aplicaciones.v1.ListCultivoTratamientosRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListCultivoTratamientosRequest.
 * Use `create(ListCultivoTratamientosRequestSchema)` to create a new message.
 */
export const ListCultivoTratamientosRequestSchema: GenMessage<ListCultivoTratamientosRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 4);

/**
 * Tratamientos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListCultivoTratamientosResponse
 */
export type ListCultivoTratamientosResponse = Message<"sextante.catalogos.aplicaciones.v1.ListCultivoTratamientosResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.aplicaciones.v1.CultivoTratamientoItem items = 1;
   */
  items: CultivoTratamientoItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListCultivoTratamientosResponse.
 * Use `create(ListCultivoTratamientosResponseSchema)` to create a new message.
 */
export const ListCultivoTratamientosResponseSchema: GenMessage<ListCultivoTratamientosResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 5);

/**
 * Coberturas de un lote NO productivo (cuerpo de agua, bosque, construccion...).
 * Es el equivalente de CultivoItem para las areas que no producen: lo consume el paso 5 del
 * wizard de registro de finca, donde al marcar un lote como "no productiva" se elige aca en
 * lugar de un cultivo. Mismos campos que CultivoItem menos las banderas de monitoreo: una
 * construccion o un cuerpo de agua no se monitorean.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.LoteNoProductivoItem
 */
export type LoteNoProductivoItem = Message<"sextante.catalogos.aplicaciones.v1.LoteNoProductivoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string nombre = 4;
   */
  nombre: string;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.LoteNoProductivoItem.
 * Use `create(LoteNoProductivoItemSchema)` to create a new message.
 */
export const LoteNoProductivoItemSchema: GenMessage<LoteNoProductivoItem> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 6);

/**
 * Pedido del catalogo de coberturas de lote no productivo.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListLotesNoProductivosRequest
 */
export type ListLotesNoProductivosRequest = Message<"sextante.catalogos.aplicaciones.v1.ListLotesNoProductivosRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListLotesNoProductivosRequest.
 * Use `create(ListLotesNoProductivosRequestSchema)` to create a new message.
 */
export const ListLotesNoProductivosRequestSchema: GenMessage<ListLotesNoProductivosRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 7);

/**
 * Coberturas que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListLotesNoProductivosResponse
 */
export type ListLotesNoProductivosResponse = Message<"sextante.catalogos.aplicaciones.v1.ListLotesNoProductivosResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.aplicaciones.v1.LoteNoProductivoItem items = 1;
   */
  items: LoteNoProductivoItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListLotesNoProductivosResponse.
 * Use `create(ListLotesNoProductivosResponseSchema)` to create a new message.
 */
export const ListLotesNoProductivosResponseSchema: GenMessage<ListLotesNoProductivosResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 8);

/**
 * Producto agroquimico del catalogo.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ProductoItem
 */
export type ProductoItem = Message<"sextante.catalogos.aplicaciones.v1.ProductoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string descripcion = 7;
   */
  descripcion: string;

  /**
   * @generated from field: string unidad_medida = 8;
   */
  unidadMedida: string;

  /**
   * @generated from field: string empresa = 10;
   */
  empresa: string;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ProductoItem.
 * Use `create(ProductoItemSchema)` to create a new message.
 */
export const ProductoItemSchema: GenMessage<ProductoItem> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 9);

/**
 * Pedido del catalogo de productos.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListProductosRequest
 */
export type ListProductosRequest = Message<"sextante.catalogos.aplicaciones.v1.ListProductosRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListProductosRequest.
 * Use `create(ListProductosRequestSchema)` to create a new message.
 */
export const ListProductosRequestSchema: GenMessage<ListProductosRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 10);

/**
 * Productos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.aplicaciones.v1.ListProductosResponse
 */
export type ListProductosResponse = Message<"sextante.catalogos.aplicaciones.v1.ListProductosResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.aplicaciones.v1.ProductoItem items = 1;
   */
  items: ProductoItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.aplicaciones.v1.ListProductosResponse.
 * Use `create(ListProductosResponseSchema)` to create a new message.
 */
export const ListProductosResponseSchema: GenMessage<ListProductosResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_aplicaciones, 11);

/**
 * Migracion a gRPC-Web de los catalogos de Cultivo/CultivoTratamiento/Producto (ver CLAUDE.md,
 * seccion migracion a gRPC-Web). A diferencia de la version REST (Api/Controllers/Catalogos/*),
 * que no tiene sincronizacion incremental y cachea bytes hasta el reinicio del server, esta
 * version SI soporta delta: ultima_sincronizacion = 0 trae el catalogo completo (incluidos los
 * eliminados, con eliminado = true); reenviar el watermark devuelto trae solo los cambios
 * posteriores. Requiere sesion (no esta en RouteHelper._routesExclude), igual que el resto de
 * dominios reales de la app Cliente salvo Login/PasswordReset.
 * 
 * Los *Item NO llevan "ultima_actualizacion" (2026-09-15): el filtro por watermark ya lo resuelve
 * el server (columna FechaActualizacion, sin exponer), y el cliente nunca leia ese campo de vuelta
 * -solo lo guardaba sin usarlo, ver GrpcCatalogosDatabase.putDeltaAsync-.
 *
 * @generated from service sextante.catalogos.aplicaciones.v1.CatalogosAplicacionesService
 */
export const CatalogosAplicacionesService: GenService<{
  /**
   * Catalogo de cultivos, por delta.
   *
   * @generated from rpc sextante.catalogos.aplicaciones.v1.CatalogosAplicacionesService.ListCultivos
   */
  listCultivos: {
    methodKind: "unary";
    input: typeof ListCultivosRequestSchema;
    output: typeof ListCultivosResponseSchema;
  },
  /**
   * Catalogo de tratamientos de cultivo, por delta.
   *
   * @generated from rpc sextante.catalogos.aplicaciones.v1.CatalogosAplicacionesService.ListCultivoTratamientos
   */
  listCultivoTratamientos: {
    methodKind: "unary";
    input: typeof ListCultivoTratamientosRequestSchema;
    output: typeof ListCultivoTratamientosResponseSchema;
  },
  /**
   * Catalogo de productos agroquimicos, por delta.
   *
   * @generated from rpc sextante.catalogos.aplicaciones.v1.CatalogosAplicacionesService.ListProductos
   */
  listProductos: {
    methodKind: "unary";
    input: typeof ListProductosRequestSchema;
    output: typeof ListProductosResponseSchema;
  },
  /**
   * Catalogo de coberturas de lote no productivo (cuerpo de agua, bosque...), por delta.
   *
   * @generated from rpc sextante.catalogos.aplicaciones.v1.CatalogosAplicacionesService.ListLotesNoProductivos
   */
  listLotesNoProductivos: {
    methodKind: "unary";
    input: typeof ListLotesNoProductivosRequestSchema;
    output: typeof ListLotesNoProductivosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catalogos_aplicaciones, 0);

